import React from 'react';
import { Box, Modal, Stack } from '@mui/material';
import "../Modals/Style.css"
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';
import assosiate from "../../Assets/associate.svg"
import location from "../../Assets/location.svg"
import participants from "../../Assets/participants.svg"
import moment from 'moment';
const CalenderModals = ({ open, onClose, event }) => {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    return (
        <Modal
            open={open}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={style} className="claender-modal">
                <div className="modal-head-heading-crossicon">
                    <div className="crie-head crie-cont">
                        {event ? event?.subject : 'No Description Available'}
                    </div>
                    <p className='cross-ic-mdl'><CloseIcon className='cross-icon-modal' onClick={onClose} /></p>
                </div>
                <div className='events-list-modal'>
                    <div className='modal-icon-btn'>
                        <p className='icon-text-modal'><PlayCircleOutlineIcon /> Category</p>
                        <div className='modat_cl_layout'>
                            {
                                event?.categories?.map(item => (
                                    <button>{item}</button>
                                ))
                            }
                        </div>
                    </div>
                    <div className='modal-icon-btn'>
                        <p className='icon-text-modal'><CalendarMonthIcon /> Event Time</p>
                        <div className='modat_cl_layout'>
                            <p>{moment(new Date(event?.start_datetime)).format("MM/DD/YYYY h:mm A")} - {moment(new Date(event?.end_datetime)).format("MM/DD/YYYY h:mm A")}</p>
                        </div>
                    </div>
                    <div className='modal-icon-btn'>
                        <p className='icon-text-modal'><img src={assosiate} alt="" /> JO Associate</p>
                        {/* {event?.primary_attendees?.length ? <button>{event?.primary_attendees?.map(item => item?.attendee_name)?.join(", ")}</button> : '-'} */}
                        {/* <div className='modat_cl_layout'>
                            {event?.primary_attendees?.length > 0 ? (
                                <button>
                                    {event.primary_attendees.map(item => item?.attendee_name).join(", ")}
                                </button>
                            ) : (
                                event?.organizer_name || '-'
                            )}
                        </div> */}
                        <div className='modat_cl_layout'>
                            {event?.primary_attendees?.length > 0 ? (
                                <button>
                                    {event.primary_attendees.map(item => item?.attendee_name).join(", ")}
                                </button>
                            ) : (
                                '-'
                            )}
                        </div>
                    </div>
                    <div className='modal-icon-btn'>
                        <p className='icon-text-modal'><img src={location} alt="" /> Location</p>
                        <div className='modat_cl_layout'>
                            <p>{event?.locations?.length ? event?.locations?.map(item => item?.displayName)?.join(", ") : "-"}</p>
                        </div>
                    </div>
                    <div className='modal-icon-btn'>
                        <p className='icon-text-modal'><img src={participants} alt="" /> Participants</p>
                        <div className='modat_cl_layout'>
                            <p>{event?.other_attendees ? event.other_attendees?.filter(item => item?.attendee_name !== "JobsOhio Engagement Calendar")?.map(item => item?.attendee_name)?.join(", \n") : '-'}</p>
                        </div>
                    </div>
                </div>
                <Stack>
                </Stack>
            </Box>
        </Modal>
    );
};
export default CalenderModals;